import { render, staticRenderFns } from "./myBacklog.vue?vue&type=template&id=b99cc57a&scoped=true"
import script from "./myBacklog.vue?vue&type=script&lang=js"
export * from "./myBacklog.vue?vue&type=script&lang=js"
import style0 from "./myBacklog.vue?vue&type=style&index=0&id=b99cc57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99cc57a",
  null
  
)

export default component.exports